import {load as loadAdverseEvents} from './adverseEvents';
import {load as loadEmployees}     from './employees';
import {load as loadEnquiries}     from './enquiries';
import {load as loadManagement}    from './management';
import {load as loadRostering}     from './rostering';
import router                      from './router';
import {load as loadServiceUsers}  from './serviceUsers';

export const load = (app) => {
	app.config(router);

	loadAdverseEvents(app);
	loadEmployees(app);
	loadEnquiries(app);
	loadManagement(app);
	loadRostering(app);
	loadServiceUsers(app);
};


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/reports/index.js